import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Collapse } from 'bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountService } from 'src/app/core/services/account.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { environment } from 'src/environments/environment';
import swal from 'sweetalert2';
import { GeolocationService } from '../../../core/services/geolocation.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { UserService } from 'src/app/core/services/user.service';
import { lastValueFrom, Subscription, switchMap, timer } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale } from 'ngx-bootstrap/locale';
import { SignalRService } from 'src/app/core/services/signalr.service';
import { User } from 'src/app/core/models/user';
import { DestinationVideoService } from 'src/app/core/services/destination-video.service';
defineLocale('de', deLocale);

export interface iSignup {
    mobileNo: string;
    lastName: string;
    firstName: string;
    email: string;
    monthlyIncome?: number;
    professiontype?: string;
    travelType: string;
    travelDate: string;
    origin: string;
    destination: string;
    travelCost?: number;
    partnerTransactionId: string;
    travelAgentName: string;
    travelBrandName: string;
    travelAgentEmailId: string;
    travelAgentMobile: string;
    longitude: number;
    latitude: number;
    ipAddress: string;
    partnerId: string;
}

/**
 * Represents the component for signing up for assistance.
 */
@Component({
    selector: 'app-assist-sign-up',
    templateUrl: './assist-sign-up.component.html',
    styleUrls: ['./assist-sign-up.component.scss'],
})
export class AssistSignUpComponent implements OnInit, OnDestroy {
    public isFormScrolledUp: boolean = false;
    private scrollListenerCleanup?: () => void;
    /**
     * Reference to the form element.
     */
    @ViewChild('form', { read: NgForm })
    public form!: NgForm;

    @ViewChild('loginForm', { read: NgForm })
    public loginForm!: NgForm;

    @ViewChild('collapseTwo')
    public collapseTwo: ElementRef;

    @ViewChild('collapseThree')
    public collapseThree: ElementRef;

    public bsConfig: any = {
        dateInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false
    };

    public consolidators: string = null;

    /**
     * Represents the sign up data.
    */
    public signUp: iSignup = {
        mobileNo: '',
        email: '',
        firstName: '',
        lastName: '',
        monthlyIncome: 0,
        professiontype: '',
        travelDate: '',
        origin: '',
        destination: '',
        travelCost: 0,
        partnerTransactionId: '1',
        travelAgentName: '',
        travelBrandName: '',
        travelAgentEmailId: '',
        travelAgentMobile: '',
        longitude: 0,
        latitude: 0,
        ipAddress: '1.1.1.1',
        travelType: '',
        partnerId: '',
    };

    /**
     * Indicates whether to show personal details or not.
     */
    public showPersonalDetails: boolean = false;

    /**
     * Indicates whether to show travel details or not.
     */
    public showTravelDetails: boolean = false;

    /**
     * The minimum date for selecting a travel date.
     */
    public minDate: string;

    /**
     * The maximum date for selecting a travel date.
     */
    public maxDate: string;

    /**
     * Represents the error message.
     */
    public error: string;

    /**
     * The IP address.
     */
    public ipAddress: string;

    /**
     * The travel agent ID.
     */
    public travelAgentId: string = '';

    public travelDateValidate = false;

    public disableTravelDetail = true;

    public disableIncomeDetail = true;

    public disableAll = false;

    //validation travel cost here
    public errorMsg: string;

    public isError: boolean;

    /**
     * Initializes the component.
     */
    public mobileRegexPattern = environment.mobileRegexPattern;

    //validate MonthlyIncome
    public monthlyErroMsg: string = '';

    public isMonthlyError: boolean = false;

    public minimumDate: Date;
    public maximumDate: Date;
    private tokenRefreshTimer: any = null;
    private visibilityListener: any = null;

    loginMobile: string = '';
    loginOtp: string = '';
    showOtpInput: boolean = false;
    resendAvailable: boolean = false;
    public timeRemaining: number = 60;
    private timerSubscription: Subscription | undefined;
    private timerKey: string = 'otpTimerLogin';

    public logoPath: string = '';
    public selectedDestinationName: string = '';

    public getDestinationHeaderName(): string {
        if (this.selectedDestinationName) {
            return this.selectedDestinationName;
        }
        const destId = this.destinationVideoService.getSelectedDestination();
        const dest = this.destinationVideoService.resolveDestination(destId);
        if (dest && dest.id !== 'global') {
            const nameMap: Record<string, string> = {
                'mumbai': 'Cordelia Cruises',
                'dubai': 'UAE',
                'south-india': 'Kerala',
                'north-india': 'Ladakh and Kashmir',
                'andaman': 'Andaman Islands',
                'europe-1': 'Western Europe',
                'europe-2': 'Southern Europe'
            };
            return nameMap[dest.id] || dest.name;
        }
        return '';
    }

    public get formHeaderTitle(): string {
        const destName = this.getDestinationHeaderName();
        if (destName) {
            return `Unlocking your ${destName} trip`;
        }
        return 'Unlocking your dream trip';
    }

    activeTab: 'signup' | 'login' = 'signup';
    otpmessage = '';

    public onHeaderOrHandleClick(): void {
        const container = document.getElementById('signupPageContainer');
        const formSection = document.getElementById('signupFormSection');
        if (!formSection) {
            return;
        }

        if (container && container.scrollTop < 80) {
            formSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } else if (container) {
            container.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            formSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }

    setActiveTab(tab: 'signup' | 'login') {
        this.activeTab = tab;

        // Reset the login form state completely to restart freshly
        this.resetLoginForm();

        const container = document.getElementById('signupPageContainer');
        if (container && container.scrollTop < 80) {
            const formSection = document.getElementById('signupFormSection');
            formSection?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }

    public isMobileTouched: boolean = false;
    public isOtpTouched: boolean = false;

    public get isLoginOtpValid(): boolean {
        return /^[0-9]{4}$/.test(this.loginOtp || '');
    }

    public get isLoginMobileValid(): boolean {
        return /^[0-9]{10}$/.test(this.loginMobile || '');
    }

    public resetLoginForm(): void {
        this.loginMobile = '';
        this.loginOtp = '';
        this.showOtpInput = false;
        this.otpmessage = '';
        this.timeRemaining = 60;
        this.resendAvailable = false;
        this.isMobileTouched = false;
        this.isOtpTouched = false;
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
            this.timerSubscription = undefined;
        }
        MemoryStorageService.removeItem(this.timerKey);
        if (this.loginForm) {
            this.loginForm.resetForm();
        }
    }

    public onLoginOtpInput(event: any): void {
        this.isOtpTouched = true;
        if (event && event.target) {
            let val = event.target.value.replace(/\D/g, '');
            if (val.length > 4) {
                val = val.substring(0, 4);
            }
            this.loginOtp = val;
            event.target.value = val;
        }
    }

    public onLoginOtpBlur(): void {
        this.isOtpTouched = true;
    }

    public onLoginMobileInput(event: any): void {
        this.isMobileTouched = true;
        if (event && event.target) {
            let val = event.target.value.replace(/\D/g, '');
            if (val.length > 10) {
                val = val.substring(0, 10);
            }
            this.loginMobile = val;
            event.target.value = val;
        }
    }

    public onLoginMobileBlur(): void {
        this.isMobileTouched = true;
    }

    public allowOnlyNumbers(event: KeyboardEvent): void {
        const char = event.key;
        if (!char.match(/[0-9]/)) {
            event.preventDefault();
        }
    }

    public async generateOtp() {
        if (this.loginMobile.length === 10) {
            this.otpmessage = '';
            this.spinner.show();
            try {
                var res = await lastValueFrom(this.accountService.GenerateOTP({ mobileNo: this.loginMobile }));
                if (res['data']) {
                    this.otpmessage = 'OTP sent successfully to ' + this.loginMobile;
                    this.showOtpInput = true;
                    this.loginOtp = '';
                    MemoryStorageService.setItem(this.timerKey, (new Date().getTime() + (60 * 1000)).toString());
                    this.loadTimer();
                    this.startTimer();
                    this.spinner.hide();
                }
                else {
                    this.otpmessage = res['error']['response_msg'];
                }
            } catch (error: any) {
                if (error.status === 0) {
                    swal.fire("No internet connection. Please check your network and try again.");
                    return;
                }
                if (error?.status === 401 && (error?.error?.message === 'Token has expired' || error?.error?.message?.toLowerCase().includes('token'))) {
                    await this.refreshPartnerTokenSilently();
                    swal.fire("Session refreshed. Please try sending OTP again.");
                    return;
                }
            } finally {
                this.spinner.hide();
            }

        } else {
            swal.fire('Please enter a valid 10-digit mobile number');
        }
    }

    public async login() {
        const otpRegex = /^[0-9]{4}$/;
        if (!this.loginOtp || !otpRegex.test(this.loginOtp)) {
            swal.fire('Please enter a valid 4-digit OTP.');
            return;
        }

        if (this.loginOtp.length === 4) {
            this.spinner.show();
            try {
                var res = await lastValueFrom(this.accountService.Login({ mobileNo: this.loginMobile, otp: this.loginOtp }));
                if (res['data']) {
                    MemoryStorageService.setItem('customerToken', res['data']['token']);
                    const user: User = { token: res['data']['sessionid'], userName: '', email: '', mobileNumber: '' }
                    this.signalRService.initSignalR(user.token);
                    this.accountService.setCurrentUser(user);
                    this.spinner.hide();
                    this.router.navigateByUrl('/assist-journey/lender-selection');
                }

                else {
                    this.otpmessage = res['error']['response_msg'];
                }
            } catch (error: any) {
                if (error.status === 0) {
                    swal.fire("No internet connection. Please check your network and try again.");
                    return;
                }
                if (error?.status === 401 && (error?.error?.message === 'Token has expired' || error?.error?.message?.toLowerCase().includes('token'))) {
                    await this.refreshPartnerTokenSilently();
                    swal.fire("Session refreshed. Please try again.");
                    return;
                }
            } finally {
                this.spinner.hide();
            }
        }
    }

    public scrollToForm(): void {
        const snapFormEl = document.getElementById('signupMainRow') || document.getElementById('snapForm') || document.getElementById('signupCardUnified');
        if (snapFormEl) {
            snapFormEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.isFormScrolledUp = true;
    }

    public scrollToTop(): void {
        const snapHeroEl = document.getElementById('snapHero');
        if (snapHeroEl) {
            snapHeroEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.isFormScrolledUp = false;
    }

    @HostListener('window:scroll', [])
    public onWindowScroll(): void {
        this.checkScrollPosition();
    }

    private checkScrollPosition(): void {
        const container = document.querySelector('.signup-page-container');
        const scrollTop = container ? container.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
        this.isFormScrolledUp = scrollTop > 50;
    }

    constructor(
        private accountService: AccountService,
        private geolocationService: GeolocationService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private sessionTimerService: SessionTimerService,
        private datePipe: DatePipe,
        private userService: UserService,
        private localeService: BsLocaleService,
        private signalRService: SignalRService,
        private destinationVideoService: DestinationVideoService
    ) { }

    public async ngOnInit(): Promise<void> {
        this.spinner.hide();
        //Clear MemoryStorageService
        MemoryStorageService.clear();

        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const container = document.querySelector('.signup-page-container');
                if (container) {
                    const scrollHandler = () => this.checkScrollPosition();
                    container.addEventListener('scroll', scrollHandler, { passive: true });
                    this.scrollListenerCleanup = () => container.removeEventListener('scroll', scrollHandler);
                }
            }, 300);
        }

        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const next11Months = new Date(today);
        next11Months.setMonth(next11Months.getMonth() + 11);

        this.minimumDate = tomorrow;
        this.maximumDate = next11Months;
        this.minDate = this.formatDate(tomorrow);
        this.maxDate = this.formatDate(next11Months);
        this.bsConfig = {
            dateInputFormat: 'DD/MM/YYYY',
            showWeekNumbers: false,
            minDate: this.minimumDate,
            maxDate: this.maximumDate
        };

        const dateNumber = today.getTime();
        this.signUp.partnerTransactionId = dateNumber.toString();

        // Proactively refresh partner token and keep alive every 10 minutes
        this.refreshPartnerTokenSilently();
        this.tokenRefreshTimer = setInterval(() => {
            this.refreshPartnerTokenSilently();
        }, 10 * 60 * 1000);

        if (typeof document !== 'undefined') {
            this.visibilityListener = () => {
                if (document.visibilityState === 'visible') {
                    const lastTokenTime = Number(MemoryStorageService.getItem('partnerTokenTime') || 0);
                    if (Date.now() - lastTokenTime > 10 * 60 * 1000) {
                        this.refreshPartnerTokenSilently();
                    }
                }
            };
            document.addEventListener('visibilitychange', this.visibilityListener);
        }

        this.geolocationService.getCurrentPosition().then((position) => {
            this.signUp.latitude = position.latitude;
            this.signUp.longitude = position.longitude;
        }).catch((error) => {
            this.error = error.message;
        });


        if (this.route.snapshot.queryParamMap.get('hideheader') || this.route.snapshot.queryParamMap.get('hidefooter')) {

        }
        //utm_source means agent id which can be found in Airtable TA-India 
        const incomingAgentId = this.route.snapshot.queryParamMap.get('utm_source')
            || this.route.snapshot.queryParamMap.get('regid')
            || this.route.snapshot.queryParamMap.get('regId')
            || this.route.snapshot.queryParamMap.get('RegID')
            || this.route.snapshot.queryParamMap.get('partnerId')
            || MemoryStorageService.getItem('travelAgentId');

        if (incomingAgentId) {
            this.travelAgentId = incomingAgentId.toString().toUpperCase();
            this.signUp.partnerId = this.travelAgentId;
            MemoryStorageService.setItem('travelAgentId', this.travelAgentId);
        }

        if (this.route.snapshot.queryParamMap.get('q')) {
            this.signUp.partnerTransactionId = await this.userService.decryptData(decodeURIComponent(this.route.snapshot.queryParamMap.get('q')!), '');
            console.log('Decrypted partnerTransactionId:', this.signUp.partnerTransactionId);
        }

        if (this.route.snapshot.queryParamMap.get('mobile') && this.route.snapshot.queryParamMap.get('email') && this.route.snapshot.queryParamMap.get('mobile') != null && this.route.snapshot.queryParamMap.get('email') != null) {
            const encodedMobile = this.route.snapshot.queryParamMap.get('mobile');
            const encodedEmail = this.route.snapshot.queryParamMap.get('email');

            if (encodedMobile) {
                this.signUp.mobileNo = await this.userService.decryptData(decodeURIComponent(encodedMobile), '');
                MemoryStorageService.setItem('userSource', 'LANDING_PAGE_WIDGET');
            }

            if (encodedEmail) {
                this.signUp.email = await this.userService.decryptData(decodeURIComponent(encodedEmail), '');
            }
        }

        this.spinner.show();
        await this.getAgentDetails();
        this.spinner.hide();

        //for logos 
        if (this.logoPath && this.logoPath.trim() && !this.logoPath.includes('INDCR00173')) {
            this.accountService.setPartnerLogo(this.logoPath);
            MemoryStorageService.setItem('partnerLogoPath', this.logoPath);
        } else if (this.consolidators && this.consolidators.length > 0 && this.consolidators[0]) {
            const consolidatorId = this.consolidators[0].toString().trim();
            const cdnBase = (environment.CDN_BaseURL || 'https://mihuruendpoint.azureedge.net/websiteimages').replace(/\/+$/, '');
            const isUat = environment.environmentName === 'uat'
                || (typeof window !== 'undefined' && (window.location.hostname.includes('uat') || window.location.hostname.includes('localhost') || window.location.hostname === '127.0.0.1'));
            const folder = isUat ? 'logos-uat' : 'logos';
            const consolidatorLogoUrl = `${cdnBase}/assets/${folder}/${consolidatorId}.png`;
            this.accountService.setPartnerLogo(consolidatorLogoUrl);
            MemoryStorageService.setItem('partnerLogoPath', consolidatorLogoUrl);
            MemoryStorageService.setItem('partnerLogoDataUrl', consolidatorLogoUrl);
            try {
                localStorage.setItem('partnerLogoPath', consolidatorLogoUrl);
                localStorage.setItem('partnerLogoDataUrl', consolidatorLogoUrl);
            } catch (e) { }
        } else {
            this.accountService.setPartnerLogo('');
            MemoryStorageService.removeItem('partnerLogoPath');
            MemoryStorageService.removeItem('partnerLogoDataUrl');
            try {
                localStorage.removeItem('partnerLogoPath');
                localStorage.removeItem('partnerLogoDataUrl');
            } catch (e) { }
        }

        // For Hiding Timer
        this.sessionTimerService.SetShowTimer(false);
        MemoryStorageService.removeItem('timerEndTime');

        // Pre-fill destination from globe selection (supports short code 'd', 'dest', or 'destination')
        const destinationParam = this.getRawDestinationParam();
        if (destinationParam) {
            this.setFormDestination(destinationParam);
        }

        this.route.queryParams.subscribe(params => {
            const p = params['d'] || params['dest'] || params['destination'] || this.getRawDestinationParam();
            if (p) {
                this.setFormDestination(p);
            }
        });

    }

    private getRawDestinationParam(): string | null {
        if (typeof window !== 'undefined') {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const p = urlParams.get('d') || urlParams.get('dest') || urlParams.get('destination');
                if (p) return p;
            } catch (e) { }
        }
        try {
            const urlTree = this.router.parseUrl(this.router.url);
            const p = urlTree.queryParams['d'] || urlTree.queryParams['dest'] || urlTree.queryParams['destination'];
            if (p) return p;
        } catch (e) { }
        return this.route.snapshot.queryParamMap.get('d')
            || this.route.snapshot.queryParamMap.get('dest')
            || this.route.snapshot.queryParamMap.get('destination')
            || this.destinationVideoService.getSelectedDestination();
    }

    private setFormDestination(param: string): void {
        const dest = this.destinationVideoService.resolveDestination(param);
        if (dest) {
            const nameMap: Record<string, string> = {
                'mumbai': 'Cordelia Cruises',
                'dubai': 'UAE',
                'south-india': 'Kerala',
                'north-india': 'Ladakh and Kashmir',
                'andaman': 'Andaman Islands',
                'europe-1': 'Western Europe',
                'europe-2': 'Southern Europe'
            };
            if (dest.id !== 'global') {
                this.selectedDestinationName = nameMap[dest.id] || dest.name;
                this.signUp.destination = this.selectedDestinationName.toUpperCase();
            }
            if (typeof window !== 'undefined' && window.sessionStorage) {
                sessionStorage.setItem('selected_destination', dest.id);
            }
            MemoryStorageService.setItem('destination', dest.id);
            this.destinationVideoService.setDestination(dest.id);
        }
    }

    public startTimer(): void {
        const now = new Date().getTime();
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
        this.timerSubscription = timer(0, 1000).pipe(switchMap(() => {
            if (this.timeRemaining > 0) {
                this.timeRemaining--;
                this.saveTimer();
                return [this.timeRemaining];
            } else {
                this.resendAvailable = true;
                MemoryStorageService.removeItem(this.timerKey);
                if (this.timerSubscription) {
                    this.timerSubscription.unsubscribe();
                }
                return [];
            }
        })).subscribe();
    }

    public saveTimer(): void {
        const expiryTime = new Date().getTime() + (this.timeRemaining * 1000);
        MemoryStorageService.setItem(this.timerKey, expiryTime.toString());
    }

    public loadTimer(): void {
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const now = new Date().getTime();
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
    }

    public async resendOtp() {
        this.timeRemaining = 60;
        this.saveTimer();
        this.resendAvailable = false;
        this.startTimer();
        let partnerAuthTokenRequest: any = {
            partnerId: this.travelAgentId,
            apiKey: 'c3a3e4b9-4564-45c0-9698-d644a19cb9bA',
        };
        await lastValueFrom(this.accountService.generatePartnerToken(partnerAuthTokenRequest)).then(
            async (token) => {
                this.accountService.resendOTPMobile(this.loginMobile, token['data']).subscribe(
                    (res) => {
                        if (res['data'] != null && res['data']['response_summary'] != null) {
                            swal.fire(res['data']['response_summary']);
                        }
                        else if (res['error'] != null && res['error']['response_summary'] == "Max 5 OTP can be send on 15min interval") {
                            MemoryStorageService.removeItem(this.timerKey);
                            if (this.timerSubscription) {
                                this.timerSubscription.unsubscribe();
                            }
                            this.timeRemaining = 60 * 15;
                            this.saveTimer();
                            this.resendAvailable = false;
                            this.startTimer();
                            swal.fire(res['error']['response_summary']);
                        }
                        else {
                            swal.fire(res['error']['response_summary']);
                        }
                    },
                    (error) => {
                        this.spinner.hide();
                        //swal.fire('Unhandled error occured, please try again later.');
                    }
                );
            },
            (error) => {
                this.spinner.hide();
                swal.fire('Please check URL and try again');
            }
        );

    }

    /**
     * Executes after the view has been initialized.
     */
    public ngAfterViewInit(): void {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const next11Months = new Date(today);
        next11Months.setMonth(next11Months.getMonth() + 11);

        this.minimumDate = tomorrow;
        this.maximumDate = next11Months;

        this.minDate = this.formatDate(tomorrow);
        this.maxDate = this.formatDate(next11Months);
        this.bsConfig = {
            dateInputFormat: 'DD/MM/YYYY',
            showWeekNumbers: false,
            minDate: this.minimumDate,
            maxDate: this.maximumDate
        };
    }

    /**
     * Formats the given date to a string in the format 'YYYY-MM-DD'.
     * @param date - The date to format.
     * @returns The formatted date string.
     */
    public formatDate(date: Date): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    /**
     * Determines whether to show validation for the given form control.
     * @param formControl - The form control to check.
     * @returns True if validation should be shown, false otherwise.
     */
    public shouldShowValidation(formControl: NgModel) {
        return (
            formControl &&
            formControl.invalid &&
            formControl.touched &&
            (formControl.dirty ||
                this.form?.submitted ||
                formControl.errors.required ||
                formControl.errors.pattern ||
                formControl.errors.min ||
                formControl.errors.max)
        );
    }

    //call partnerlogohere
    public validateTravelDate() {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        if (!this.signUp.travelDate) {
            this.travelDateValidate = true;
            return;
        }
        const selectedDate = new Date(this.signUp.travelDate);
        if (selectedDate < new Date(this.formatDate(tomorrow)) || (this.maximumDate && selectedDate > this.maximumDate)) {
            this.travelDateValidate = true;
            return;
        }
        this.travelDateValidate = false;
    }

    // public partnerLogo() {
    //     const body = { RegID: this.travelAgentId };
    //     this.accountService.getLogoUrl(body).subscribe(
    //         (res: any) => {
    //             if (res.status === 'success' && res.response.Error != 'true') {
    //                 this.accountService.setPartnerLogo(res.response.Logo)
    //             }
    //         });
    // }

    /**
     * Submits the sign up form.
     */
    public async refreshPartnerTokenSilently(): Promise<string | null> {
        const partnerId = this.travelAgentId || this.signUp.partnerId || MemoryStorageService.getItem('travelAgentId') || 'INDTA00308';
        const partnerAuthTokenRequest: any = {
            partnerId: partnerId,
            apiKey: 'c3a3e4b9-4564-45c0-9698-d644a19cb9bA',
        };
        try {
            const tokenRes: any = await lastValueFrom(this.accountService.generatePartnerToken(partnerAuthTokenRequest));
            if (tokenRes?.data) {
                const partnerToken = tokenRes.data;
                MemoryStorageService.setItem('partnerToken', partnerToken);
                MemoryStorageService.setItem('accessToken', partnerToken);
                MemoryStorageService.setItem('partnerTokenTime', Date.now().toString());
                const user: User = { token: partnerToken, userName: '', email: '', mobileNumber: '' };
                MemoryStorageService.setItem('user', JSON.stringify(user));
                this.accountService.setCurrentUser(user);
                return partnerToken;
            }
        } catch (e) {
            console.warn('Silent partner token refresh error:', e);
        }
        return null;
    }

    /**
     * Submits the sign up form data.
     */
    public async submit() {
        this.validateMonthlyincome({ target: { name: 'monthlyIncome' } });
        if (this.isMonthlyError) {
            swal.fire(this.monthlyErroMsg || 'Please enter valid monthly income');
            return;
        }
        this.validateTravelDate();
        if (this.travelDateValidate) {
            swal.fire('Please select travel date within the next 11 months.');
            return;
        }

        this.spinner.show();
        await this.getAgentDetails();

        const executeSignupWithToken = async (retryCount = 0): Promise<void> => {
            const partnerId = this.travelAgentId || this.signUp.partnerId || MemoryStorageService.getItem('travelAgentId') || 'INDTA00308';
            const partnerAuthTokenRequest: any = {
                partnerId: partnerId,
                apiKey: 'c3a3e4b9-4564-45c0-9698-d644a19cb9bA',
            };

            if (!this.route.snapshot.queryParamMap.get('q')) {
                this.signUp.partnerTransactionId = new Date().getTime().toString();
            }

            try {
                const tokenRes: any = await lastValueFrom(this.accountService.generatePartnerToken(partnerAuthTokenRequest));
                const partnerToken = tokenRes?.data;
                if (!partnerToken) {
                    throw new Error('Unable to generate partner token');
                }

                MemoryStorageService.setItem('partnerToken', partnerToken);
                MemoryStorageService.setItem('accessToken', partnerToken);

                const res: any = await lastValueFrom(this.accountService.signup(this.signUp, partnerToken));

                const errorMsg = (res?.error?.response_summary || res?.error?.response_msg || res?.error?.message || '').toLowerCase();
                if (res?.error && (errorMsg.includes('token') && errorMsg.includes('expir')) && retryCount < 2) {
                    console.warn('Signup returned token expired in response, retrying with fresh token...');
                    return await executeSignupWithToken(retryCount + 1);
                }

                if (res?.data != null) {
                    MemoryStorageService.setItem('partnerToken', partnerToken);
                    MemoryStorageService.setItem('mobile', this.signUp.mobileNo);
                    MemoryStorageService.setItem('email', this.signUp.email);
                    MemoryStorageService.setItem('firstname', this.signUp.firstName);
                    MemoryStorageService.setItem('lastname', this.signUp.lastName);
                    MemoryStorageService.setItem('TravelCost', "" + this.signUp.travelCost);
                    MemoryStorageService.setItem('accessToken', partnerToken);
                    MemoryStorageService.setItem('otpTimer', (new Date().getTime() + (60 * 1000)).toString());
                    this.spinner.hide();
                    this.router.navigateByUrl('/assist-journey/submit-otp');
                } else if (res?.error != null) {
                    this.spinner.hide();
                    swal.fire(res.error.response_summary || res.error.response_msg || 'There was an error! Please try again!');
                } else {
                    this.spinner.hide();
                    swal.fire('There was an error! Please try again!');
                }
            } catch (err: any) {
                const errMsg = (err?.error?.message || err?.error?.response_summary || err?.message || '').toLowerCase();
                const isTokenExpired = err?.status === 401 || (errMsg.includes('token') && errMsg.includes('expir'));
                if (isTokenExpired && retryCount < 2) {
                    console.warn('Signup threw 401/token expired error, retrying with fresh token...');
                    return await executeSignupWithToken(retryCount + 1);
                }
                this.spinner.hide();
                swal.fire(err?.error?.response_summary || err?.error?.message || 'There was an error! Please try again!');
            }
        };

        await executeSignupWithToken();
    }

    //clear monthlyincome
    public clearInitialValue(event: any): void {
        const fieldName = event.target.name;
        if (fieldName === 'monthlyIncome' && this.signUp.monthlyIncome === 0) {
            this.signUp.monthlyIncome = null;
        } else if (fieldName === 'travelCost' && this.signUp.travelCost === 0) {
            this.signUp.travelCost = null;
        }
    }

    //GetAgentDetails
    public async getAgentDetails(): Promise<void> {
        if (this.travelAgentId != '') {
            try {
                const agentDetails: any = await this.accountService.getAgentDetails(this.travelAgentId.toUpperCase()).toPromise();
                console.log(agentDetails);
                if (agentDetails != null) {
                    this.signUp.travelAgentName = agentDetails.ownerDirectorName;
                    this.signUp.travelBrandName = agentDetails.brandName;
                    this.signUp.travelAgentEmailId = agentDetails.email;
                    this.signUp.travelAgentMobile = agentDetails.mobile.toString();
                    this.consolidators = agentDetails.consolidator || null;
                    this.logoPath = agentDetails.logoUrl;
                    if (agentDetails != null && agentDetails.consolidator != null && agentDetails.consolidator.length > 0) {
                        MemoryStorageService.setItem("consolidatorId", agentDetails.consolidator[0] || null);
                    }
                    MemoryStorageService.setItem("userSource", MemoryStorageService.getItem('userSource') === 'LANDING_PAGE_WIDGET' ? 'LANDING_PAGE_WIDGET' : 'LANDING_PAGE');
                } else {
                    swal.fire('Please check Agent ID and try again!');
                }
            } catch (error) {
                console.error('Error fetching agent details:', error);
            }
        }
    }

    public allowOnly(event: KeyboardEvent, type: string): void {
        const input = event.target as HTMLInputElement;
        let allowedPattern;

        if (type === 'numbers') {
            allowedPattern = /[^0-9]/g; // Match anything that's not a number
        } else if (type === 'alphabets') {
            allowedPattern = /[^a-zA-Z\s']/g; // Match anything that's not a letter
        }

        // Use input event to handle changes
        input.addEventListener('input', (e: Event) => {
            const currentValue = input.value;
            input.value = currentValue.replace(allowedPattern, '');
        });
    }

    public toUpperCase(event: any) {
        event.target.value = event.target.value.toUpperCase();
    }

    public onDestinationChange(dest: string): void {
        if (dest && dest.trim().length >= 2) {
            const resolved = this.destinationVideoService.resolveDestination(dest);
            if (resolved && resolved.id !== 'global') {
                this.destinationVideoService.setDestination(resolved.id);
            }
        }
    }

    public validateTravelCost() {
        const minCost = 10000;
        const maxCost = 1000000;
        const currentCost = this.signUp.travelCost;

        if (this.signUp.travelCost == null) {
            this.isError = true;
            this.errorMsg = 'Trip cost is required.';
            return;
        }

        if (currentCost < minCost) {
            this.errorMsg = `The minimum trip cost is ₹${minCost}.`;
            this.isError = true;
        } else if (currentCost > maxCost) {
            this.errorMsg = `The maximum trip cost is ₹${maxCost}.`;
            this.isError = true;
        }
        else {
            this.isError = false;
        }

    }

    public validateMonthlyincome(event?: any) {
        const fieldName = event?.target?.name || 'monthlyIncome';

        if (fieldName === 'monthlyIncome' && this.signUp.monthlyIncome === 0) {
            this.signUp.monthlyIncome = null;
        }

        const minIncome = 15000;
        const maxIncome = 10000000;
        const currentIncome = this.signUp.monthlyIncome;

        if (this.signUp.monthlyIncome == null || this.signUp.monthlyIncome === undefined || (typeof this.signUp.monthlyIncome === 'string' && !(this.signUp.monthlyIncome as string).trim())) {
            this.isMonthlyError = true;
            this.monthlyErroMsg = 'Monthly Income is required.';
            return;
        }

        if (currentIncome < minIncome) {
            this.monthlyErroMsg = `The minimum Income is ₹${minIncome.toLocaleString('en-IN')}.`;
            this.isMonthlyError = true;
        } else if (currentIncome > maxIncome) {
            this.monthlyErroMsg = `The maximum Income is ₹1,00,00,000 (₹1 Crore).`;
            this.isMonthlyError = true;
        } else {
            this.isMonthlyError = false;
            this.monthlyErroMsg = '';
        }
    }

    public onInputChange(value: string) {
        this.signUp.mobileNo = value.replace(/\D/g, '');
    }

    public onInputDateChange(event: KeyboardEvent) {
        const key = event.key.toLowerCase();
        if (key !== 'backspace' && key !== 'tab') {
            event.preventDefault();
        }
    }

    public showTravelDetailsFun(val) {
        this.showTravelDetails = val;
        setTimeout(() => {
            if (this.collapseThree) {
                const collapse = new Collapse(this.collapseThree.nativeElement, { toggle: false });
                collapse.show();
            }
        });
    }

    public async GetSignInData(val: boolean) {
        if (!val) {
            return;
        }

        this.spinner.show();
        try {
            const lastTokenTime = Number(MemoryStorageService.getItem('partnerTokenTime') || 0);
            let partnerToken = MemoryStorageService.getItem('partnerToken') || MemoryStorageService.getItem('accessToken');

            // If token is missing or older than 10 minutes, proactively refresh before calling status API
            if (!partnerToken || (Date.now() - lastTokenTime > 10 * 60 * 1000)) {
                partnerToken = await this.refreshPartnerTokenSilently();
            }

            const fetchStatus = async (token: string | null) => {
                return await lastValueFrom(
                    this.accountService.getApplicationByMobile(
                        this.signUp.mobileNo,
                        this.signUp.email,
                        token || undefined
                    )
                );
            };

            let res: any = null;
            try {
                res = await fetchStatus(partnerToken);
            } catch (err: any) {
                const isTokenExpired =
                    err?.status === 401 ||
                    (err?.error?.message && err.error.message.toLowerCase().includes('token')) ||
                    (typeof err?.error === 'string' && err.error.toLowerCase().includes('token'));

                if (isTokenExpired) {
                    console.warn('Token expired during application status check. Refreshing token and retrying...');
                    partnerToken = await this.refreshPartnerTokenSilently();
                    res = await fetchStatus(partnerToken);
                } else if (err?.status === 404) {
                    // 404 means no previous application found, which is completely valid for new registrations
                    res = null;
                } else {
                    throw err;
                }
            }

            // Check if response body indicates token expiration
            const errorMsg = (res?.error?.response_summary || res?.error?.response_msg || res?.error?.message || '').toLowerCase();
            if (res?.error && errorMsg.includes('token') && errorMsg.includes('expir')) {
                console.warn('Response indicated token expired, refreshing and retrying...');
                partnerToken = await this.refreshPartnerTokenSilently();
                res = await fetchStatus(partnerToken);
            }

            if (res && res.error) {
                if (res.error.type === 'Active') {
                    swal.fire(res.error.msg);
                    this.activeTab = 'login';
                    this.loginMobile = this.signUp.mobileNo;
                    return;
                } else if (res.error.type === 'Declined') {
                    swal.fire(res.error.msg);
                    return;
                }
            }

            this.showPersonalDetails = val;
            setTimeout(() => {
                if (this.collapseTwo) {
                    const collapse = new Collapse(this.collapseTwo.nativeElement, { toggle: false });
                    collapse.show();
                }
            });
        } catch (err: any) {
            console.error('Error in GetSignInData:', err);
            if (err?.status === 0) {
                swal.fire('No internet connection. Please check your network and try again.');
                return;
            }

            // If an unexpected non-blocking error occurs, do not leave the user stuck on the Proceed button.
            // Allow them to proceed to fill personal details.
            this.showPersonalDetails = val;
            setTimeout(() => {
                if (this.collapseTwo) {
                    const collapse = new Collapse(this.collapseTwo.nativeElement, { toggle: false });
                    collapse.show();
                }
            });
        } finally {
            this.spinner.hide();
        }
    }

    public handleTravelDateChange(value: Date) {
        const year = value.getFullYear();
        const month = (value.getMonth() + 1).toString().padStart(2, '0');
        const date = value.getDate().toString().padStart(2, '0');

        this.signUp.travelDate = `${year}-${month}-${date}`;
    }


    private restoreBase64(value: string): string {
        // Replace lowercase 'a-z' with correct Base64 equivalents, if necessary
        return value.replace(/[^a-zA-Z0-9+/=]/g, '');
    }


    private decodeBase64(value: string): string {
        try {
            return atob(value);
        } catch (error) {
            console.error('Invalid Base64 string:', value);
            return '';
        }
    }

    public ngOnDestroy(): void {
        if (this.scrollListenerCleanup) {
            this.scrollListenerCleanup();
        }
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
        if (this.tokenRefreshTimer) {
            clearInterval(this.tokenRefreshTimer);
            this.tokenRefreshTimer = null;
        }
        if (this.visibilityListener && typeof document !== 'undefined') {
            document.removeEventListener('visibilitychange', this.visibilityListener);
            this.visibilityListener = null;
        }
    }
}
